<template>
    <b-card no-body class="overflow-hidden">
        <b-row no-gutters>
            <b-col md="4">
                <div class="item-photo" :style="style"></div>
            </b-col>
            <b-col md="8">
                <b-card-body
                    title-tag="h6"
                    :title="
                        `${entry.person.name} - Doc: ${entry.person.document} (${entry.visitor_type.name})`
                    "
                >
                    <b-card-text>
                        <table class="table table-sm" v-if="!goingOut">
                            <tbody>
                                <tr>
                                    <td><strong>Fecha Ingreso</strong></td>
                                    <td>{{ entry.created_at | datetime }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Duración</strong></td>
                                    <td>{{ entry.created_at | duration }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Destino</strong></td>
                                    <td>{{ entry.destination.name }}</td>
                                </tr>
                                <tr v-if="!!entry.visited_person">
                                    <td><strong>Persona Visitada</strong></td>
                                    <td>{{ entry.visited_person.name }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Registrado por</strong></td>
                                    <td>{{ entry.user.name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <b-form-textarea
                            v-else
                            v-model="notes"
                            rows="5"
                            autofocus
                        ></b-form-textarea>
                    </b-card-text>
                    <b-row>
                        <b-col>
                            <app-form-textarea-input
                                v-if="!goingOut"
                                :readonly="true"
                                label="Notas"
                                id="notas"
                                v-model="previousNotes"
                            ></app-form-textarea-input>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-btn
                            variant="primary"
                            v-if="!goingOut"
                            @click="goingOut = true"
                            >Dar Salida</b-btn
                        >
                        <div v-else>
                            <b-btn variant="secondary" @click="goingOut = false"
                                >Cancelar</b-btn
                            >
                            <b-btn variant="confirm" @click="register"
                                >Confirmar</b-btn
                            >
                        </div>
                    </div>
                </b-card-body>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        goingOut: false,
        notes: '',
        previousNotes: '',
    }),
    computed: {
        style() {
            return {
                backgroundImage: `url(${
                    !!this.entry.person.photo
                        ? this.entry.person.photo
                        : 'images/generic_avatar.png'
                })`,
                backgroundPosition: 'center',
                backgroundSize: !!this.entry.person.photo ? 'cover' : 'contain',
                backgroundRepeat: 'no-repeat',
            }
        },
    },
    methods: {
        async register() {
            const { data } = await repo.post(
                `entries/${this.entry.id}/person-departure`,
                {
                    notes: this.notes,
                    user: this.user.id,
                }
            )
            toastr.success('La salida fue registrada satisfactoriamente')
            this.notes = ''
            this.goingOut = false

            const params = { isPassenger: data.result.isPassenger }
            this.$emit('departured', params)
        },
        handleControlAccessNotes() {
            const noteTypes = { entry: 'Ingreso', departure: 'Salida' }
            this.previousNotes = this.entry.person.accessControlComments
                .map(
                    (item) =>
                        `- [${item.created_at}] ${item.notes} (${
                            noteTypes[item.type]
                        })`
                )
                .join('\n')
        },
    },
    created(){
        this.handleControlAccessNotes();
    }
}
</script>
<style scoped>
.item-photo {
    height: 175px;
    display: flex;
    align-items: center;
}
</style>
